import SupportPage from "./support";

export default SupportPage;
